<template>
  <section class="hero">
    <div class="header container">
      <a href="/" class="header__logo">
        <img src="../assets/logo.png">
      </a>
      <h1 class="hero__title --fade-in-up" data-vertical-ivp-class="--animate">Advancing Natural Wellness w/ a Profitable Hemp and CBD Product Portfolio</h1>
      <a class="primary-button --fade-in-up --delay-1" data-vertical-ivp-class="--animate" href="#">SIGN UP HERE</a>
    </div>
    <div class="hero__intro container">
      <div class="hero__img --fade-in-right --delay-1" data-vertical-ivp-class="--animate">
        <img src="../assets/hero/img-1.png">
      </div>
      <div class="hero__text --fade-in-left --delay-1" data-vertical-ivp-class="--animate">
        <p class="hero__description">
          Onassis Holdings Corp. (OTC: ONSS) has multiple wellness products and brands in its portfolio with a focus
          on holistic health through CBD and Hemp Oil products and technology, giving the company potential
          that exceeds a single market. The company acquires and operates multiple influential businesses
          within the holistic health industry, is involved in white labelling, and has more developments on the way.
        </p>
        <p class="hero__description">
          The compound  is being utilized for its long list of potential holistic benefits, creating one of the fastest
          growing global markets: $47.22 billion by 2028 at a compound annual growth rate (CAGR) of 21.3%,
          and overlapping with a $404B holistic health market opportunity.
        </p>
      </div>
    </div>
  </section>
  <section class="hero__footer">
    <div class="container">
      <div class="hero__footer-cont --fade-in-left" data-vertical-ivp-class="--animate">
        <a href="https://finance.yahoo.com/news/onassis-launches-sales-top-line-173000870.html" target="_blank">
          Onassis Launches Sales of Top of Line Extrax CBD Vapes </a>
      </div>
      <div class="hero__footer-cont --fade-in-left --delay-2" data-vertical-ivp-class="--animate">
        <a href="https://www.prnewswire.com/news-releases/onassis-has-signed-a-6m-binding-acquisition-agreement-301164894.html" target="_blank">
          Onassis Has Signed a $6M Binding Acquisition Agreement</a>
      </div>
      <div class="hero__footer-cont --fade-in-left --delay-4" data-vertical-ivp-class="--animate">
        <a href="https://www.onassis-holdings.com/mgc-pharmaceuticals-asxmxc-to-sell-nutraceutical-subsidiary-to-u-s-wellness-company/" target="_blank">
          MGC Pharmaceuticals Selling Nutraceuticals Subsidiary to US CBD and Hemp Wellness Company</a>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'hero',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/hero.scss";
</style>
